import type { TypeRecherche } from '@/features/application/types'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export type FavoriDialogModel =
  | {
      visible: false
    }
  | {
      visible: true
      titre: string
      type: TypeRecherche
    }
const CLOSE_DIALOG = { visible: false } as const

export const useFavoriDialogStore = defineStore('favoriDialog', () => {
  let dialogResolver: ((value: string | PromiseLike<string>) => void) | null = null

  const dialogModel = ref<FavoriDialogModel>({ ...CLOSE_DIALOG })
  const close = function () {
    dialogResolver = null
    dialogModel.value = CLOSE_DIALOG
  }

  const save = function () {
    if ('titre' in dialogModel.value) {
      dialogResolver?.call(null, dialogModel.value.titre)
      close()
    }
  }

  const showDialog = function (type: TypeRecherche): Promise<string> {
    return new Promise<string>((resolve) => {
      dialogModel.value = {
        titre: '',
        type,
        visible: true,
      }
      dialogResolver = resolve
    })
  }

  return { dialogModel, close, save, showDialog }
})

